import { render, staticRenderFns } from "./NewEditPlanejamentoDeAula.vue?vue&type=template&id=da8d39ce&scoped=true"
import script from "./NewEditPlanejamentoDeAula.vue?vue&type=script&lang=js"
export * from "./NewEditPlanejamentoDeAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8d39ce",
  null
  
)

export default component.exports